import React from "react";
import "./graphs.css";
import { COLORS } from "./utils";

export default function Legend({
    legendData,
    legendLabel = [],
}: {
    legendData: string[][];
    legendLabel?: string[];
}) {
    if (!legendData) return <></>;
    const containsLabels = legendData.length === legendLabel.length;
    return (
        <div className="legendContainer">
            {legendData.map((line, lineIndex) => (
                <div key={lineIndex} style={containsLabels ? { width: "75%" } : {}}>
                    {containsLabels ? (
                        <span className="legendLabel">{legendLabel[lineIndex] + ":"}</span>
                    ) : null}
                    <div className="legend">
                        {line.map((label, i) => (
                            <div
                                key={label}
                                style={{ background: COLORS[i] }}
                                className="legendBlock"
                            >
                                <span>{label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
